module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-3-61055daed26ebc048e4ddb41d429776a.png";